import { z } from "zod";

// Prompt Template Schema
export const PromptTemplateSchema = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid().nullable().optional(), // NULL for System Templates
    name: z.string().trim().min(1, "Template name is required"),
    slug: z.string().trim().min(1, "Slug is required").regex(/^[a-z0-9-]+$/, "Slug must be lowercase alphanumeric with hyphens"),
    description: z.string().trim().optional(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
});

// Prompt Version Schema
export const PromptVersionSchema = z.object({
    id: z.string().uuid(),
    templateId: z.string().uuid(),
    version: z.number().int().positive(),
    systemPrompt: z.string().trim().optional(),
    userPrompt: z.string().trim().optional(), // Liquid/Handlebars template
    modelId: z.string().uuid().optional(), // Preferred model for this version
    configJson: z.string().optional().default("{}"), // JSON string: { temperature: 0.7, json_mode: true }
    isActive: z.boolean().default(false),
    changeLog: z.string().trim().optional(),
    createdAt: z.string().datetime().optional(),
});

// Types
export type PromptTemplate = z.infer<typeof PromptTemplateSchema>;
export type PromptVersion = z.infer<typeof PromptVersionSchema>;
